/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";

//Styles
import "./policies.scss";

const Policies = (reservation) => {
  return (
    <section
      className={`productPage__policies ${reservation ? "reservation" : ""}`}
    >
      <h2>Qué tienes que saber</h2>

      <div className="productPage__container__policies">
        <div className="productPage__container__policy">
          <h3>Documentación a presentar</h3>
          <p>Identificación con fotografía y pasaporte válidos</p>
          <p>
            Licencia de conducir nacional, válida y original que demuestre que
            ha estado autorizado para conducir por un mínimo de 2 años
          </p>
          <p>
            Comprobante de Confirmación de Reserva en la ubicación de alquiler
          </p>
        </div>
        <div className="productPage__container__policy">
          <h3>Coberturas y garantías</h3>
          <p>
            La tarifa incluye cobertura con una franquicia o deducible que varía
            según el tipo de vehículo
          </p>
          <p>
            La franquicia es el importe que debe abonar en caso de algún
            siniestro
          </p>
          <p>Puede adquirir coberturas y garantías adicionales</p>
        </div>
        <div className="productPage__container__policy">
          <h3>Política de cancelación</h3>
          <p>
            El cargo de cancelación hasta 24 Hs previas a la fecha y hora para
            retirar la unidad del 4% del importe total de reserva
          </p>
          <p>
            El cargo de cancelación dentro de las 24 Hs a la fecha y hora para
            retirar la unidad equivale a la tarifa de un día del auto reservado
            más 4% del importe total de reserva
          </p>
        </div>
      </div>
    </section>
  );
};

export default Policies;
